import { Link, Outlet, createFileRoute } from "@tanstack/react-router";

import { cn } from "~/lib/cn";

export const Route = createFileRoute("/_public/brand")({
  component: BrandLayout,
  staticData: { title: "Brand" },
});

const tabs = [
  { to: "/brand/guideline", label: "Guideline" },
  { to: "/brand/components", label: "Components" },
] as const;

function BrandLayout() {
  return (
    <div>
      <nav className="border-b border-gray-200 bg-white">
        <div className="mx-auto flex max-w-screen-xl items-center gap-1 px-4 py-2">
          {tabs.map((tab) => (
            <Link
              key={tab.to}
              to={tab.to}
              className={cn(
                "rounded-full px-4 py-1.5 text-sm font-medium transition-colors",
                "text-gray-600 hover:bg-gray-100 hover:text-gray-900",
              )}
              activeProps={{
                className: "!bg-purple-100 !text-purple-700",
              }}
            >
              {tab.label}
            </Link>
          ))}
        </div>
      </nav>
      <Outlet />
    </div>
  );
}
